// src/components/ui/FormFields/FormPageHeader.jsx (MIGRATED TO DESIGN SYSTEM)
/**
 * This file now forwards to the unified design system PageHeader component
 * The design system PageHeader includes all FormPageHeader functionality
 * Maintained for backward compatibility during migration
 */
import PageHeader from '../PageHeader';

export default PageHeader;